import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import './translations/i18n';

ReactDOM.render(<App />, document.getElementById('root'));
